"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/empty/style");
var _empty = _interopRequireDefault(require("antd/lib/empty"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./ClinicianAppointmentStatistics.less");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title;
var ClinicianAppointmentStatistics = function ClinicianAppointmentStatistics(_ref) {
  var statistics = _ref.statistics;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ClinicianAppointmentStatistics flex-grow flex"
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-shadow ant-card-narrow flex-grow",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Appointment statistics"),
    bordered: false
  }, !(0, _lodash.isEmpty)(statistics) ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 9,
      offset: 0
    }
  }, "Number of patients:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "ant-card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 14,
      offset: 1
    }
  }, statistics === null || statistics === void 0 ? void 0 : statistics.numberOfPatients)), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "card-label",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 9,
      offset: 0
    },
    span: 9
  }, "Calls made:"), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "ant-card-text",
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 14,
      offset: 1
    },
    offset: 1,
    span: 14
  }, statistics === null || statistics === void 0 ? void 0 : statistics.callsMade))) : /*#__PURE__*/_react.default.createElement(_empty.default, {
    image: _empty.default.PRESENTED_IMAGE_SIMPLE
  })));
};
ClinicianAppointmentStatistics.propTypes = {
  statistics: _propTypes.default.shape({
    numberOfPatients: _propTypes.default.any,
    callsMade: _propTypes.default.any,
    messagesSent: _propTypes.default.any
  })
};
var _default = ClinicianAppointmentStatistics;
exports.default = _default;